export default __webpack_public_path__ + "static/media/i034vp.4cc94c1a.webp";